<script lang="ts" setup>
import { chartColors } from '@forgd/ui-kit/charts/lib/colors'
import { Card } from '@forgd/ui-kit/card'
import { useQuery } from '@pinia/colada'

const BAR_CHART_HEIGHT = 142
const BAR_CHART_GAP = 10

const fdvQuery = useQuery({
  ...buildApiQuerySSRSafe('/public-research/fdv-by-initial-circ-supply', {
    params: () => ({ query: {} }),
  }),
  refetchOnWindowFocus: false,
})

const avgFdvByGroup = computed(() =>
  fdvQuery.data.value?.groups?.map((g, i) => ({ index: i, value: g.averageFdv ?? 0, label: g.group })) ?? [],
)
const medianFdvByGroup = computed(() =>
  fdvQuery.data.value?.groups?.map((g, i) => ({ index: i, value: g.medianFdv ?? 0, label: g.group })) ?? [],
)
</script>

<template>
  <Card class="grid grid-cols-1 divide-y divide-default sm:grid-cols-2 sm:divide-x sm:divide-y-0">
    <div class="flex flex-col gap-2 p-5">
      <h3 class="text-xs font-semibold text-primal">
        Avg. FDV by Init. Circulating Supply
      </h3>
      <PrBarChart
        :data="avgFdvByGroup"
        :color="chartColors.tokenDesigner[0]!"
        :height="BAR_CHART_HEIGHT"
        :gap="BAR_CHART_GAP"
        title="Avg FDV ($) | Init. Circulating Supply"
      />
    </div>
    <div class="flex flex-col gap-2 p-5">
      <h3 class="text-xs font-semibold text-primal">
        Median FDV by Init. Circulating Supply
      </h3>
      <PrBarChart
        :data="medianFdvByGroup"
        :color="chartColors.tokenDesigner[1]!"
        :height="BAR_CHART_HEIGHT"
        :gap="BAR_CHART_GAP"
        title="Median FDV ($) | Init. Circulating Supply"
      />
    </div>
  </Card>
</template>
